import { Action } from '@ngrx/store';
import { type } from '../../util';

import { Appointment } from '../../shared/models/appointment.model';

export const actionTypes = {
  SET_APPOINTMENTS: type('[Appointments] Set the appointments'),
  RESET_APPOINTMENTS: type('[Appointments] Reset the appointments'),
};

export class SetAppointments implements Action {
  type = actionTypes.SET_APPOINTMENTS;

  constructor(public payload: Appointment[]) { }
}

export class ResetAppointments implements Action {
  type = actionTypes.RESET_APPOINTMENTS;
}

export type Actions
  = SetAppointments
  | ResetAppointments;



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/appointments/appointments.actions.ts